import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";
import { getConsent, setConsent, isAnalyticsConfigured } from "@/lib/analytics";

export function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isAnalyticsConfigured()) return;
    setVisible(getConsent() === null);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t border-eg-gold/30 bg-eg-dark px-4 py-4 text-white shadow-lg">
      <div className="mx-auto flex max-w-5xl flex-col items-center justify-between gap-3 sm:flex-row">
        <p className="text-sm text-white/90">
          Usamos cookies de análise para entender como você usa a loja. Veja nossa{" "}
          <Link to="/privacidade" className="underline hover:text-eg-gold">
            Política de Privacidade
          </Link>
          .
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            onClick={() => {
              setConsent("denied");
              setVisible(false);
            }}
            className="rounded-md border border-white/30 px-4 py-2 text-sm font-medium text-white hover:bg-white/10 transition-colors"
          >
            Recusar
          </button>
          <button
            type="button"
            onClick={() => {
              setConsent("granted");
              setVisible(false);
            }}
            className="rounded-md bg-eg-gold px-4 py-2 text-sm font-semibold text-eg-dark hover:bg-eg-goldhover transition-colors"
          >
            Aceitar
          </button>
        </div>
      </div>
    </div>
  );
}
